/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Why the Parental Control rule engine blocked a content item.
 * `NONE` means the item is allowed.
 */
enum ParentalBlockReason {
  /** The item is allowed. */
  NONE = "NONE",

  /** A movie rating exceeds its limit. Wins over a TV violation (WEB-PC-013). */
  MOVIE_RATING = "MOVIE_RATING",

  /** A TV rating exceeds its limit. */
  TV_RATING = "TV_RATING",

  /** A rating of another limited type (Canada, LATAM, …) exceeds its limit. */
  RATING = "RATING",

  /**
   * The item has no typed rating and the unrated policy blocks it
   * (WEB-PC-050), or a not-rated value (NR, TV-NR) has no service level to
   * compare (WEB-PC-015, OQ-19).
   */
  UNRATED = "UNRATED",

  /** A value of a limited, delivered type cannot be mapped or ranked. Fail closed (WEB-PC-017). */
  UNMAPPED_RATING = "UNMAPPED_RATING",

  /** The item's rating could not be fetched. Fail safe (WEB-PC-041, WEB-PC-047). */
  RATING_UNAVAILABLE = "RATING_UNAVAILABLE",

  /** Effective settings or the rating taxonomy are not available. Fail safe. */
  SETTINGS_UNAVAILABLE = "SETTINGS_UNAVAILABLE"
}

export { ParentalBlockReason };
